import { Signal } from "@lit-labs/signals";
import type {
  IWritableLiveEventFormState,
  ILiveEventFormState,
  LiveEventFormData,
  ValidationErrors,
  UIToggleState,
  AvailableLink,
  StreamSource,
} from "./types";

export class LiveEventFormState implements IWritableLiveEventFormState {
  readonly formData = new Signal.State<LiveEventFormData>({
    title: "",
    description: "",
    feeEuros: "",
    scheduledDate: "",
    scheduledTime: "",
    maxAttendees: "",
    whatsappUrl: "",
    ctaText: "",
    durationMinutes: "",
    language: "nl",
  });

  readonly validationErrors = new Signal.State<ValidationErrors>({});
  readonly isSubmitting = new Signal.State<boolean>(false);

  readonly uiToggles = new Signal.State<UIToggleState>({
    showDescription: false,
    showMaxAttendees: false,
    showWhatsApp: false,
    showCtaText: false,
    showLinkedLinks: false,
  });

  readonly contentTier = new Signal.State<"premium">("premium");
  readonly thumbnailFileId = new Signal.State<string | undefined>(undefined);
  readonly thumbnailUrl = new Signal.State<string | undefined>(undefined);
  readonly linkedLinkIds = new Signal.State<string[]>([]);
  readonly availableLinks = new Signal.State<AvailableLink[]>([]);
  readonly isLoadingLinks = new Signal.State<boolean>(false);
  readonly eventId = new Signal.State<string | undefined>(undefined);
  readonly provisionalEventId = new Signal.State<string | undefined>(undefined);
  readonly isLoading = new Signal.State<boolean>(false);
  readonly streamSource = new Signal.State<StreamSource>("webcam");

  reset(): void {
    this.formData.set({
      title: "",
      description: "",
      feeEuros: "",
      scheduledDate: "",
      scheduledTime: "",
      maxAttendees: "",
      whatsappUrl: "",
      ctaText: "",
      durationMinutes: "",
      language: "nl",
    });
    this.validationErrors.set({});
    this.isSubmitting.set(false);
    this.uiToggles.set({
      showDescription: false,
      showMaxAttendees: false,
      showWhatsApp: false,
      showCtaText: false,
      showLinkedLinks: false,
    });
    this.contentTier.set("premium");
    this.thumbnailFileId.set(undefined);
    this.thumbnailUrl.set(undefined);
    this.linkedLinkIds.set([]);
    this.eventId.set(undefined);
    this.provisionalEventId.set(undefined);
    this.isLoading.set(false);
    this.streamSource.set("webcam");
  }
}

// Type cast for read-only access
export function asReadonlyLiveEventFormState(state: LiveEventFormState): ILiveEventFormState {
  return state as ILiveEventFormState;
}
